import { Component, ChangeDetectionStrategy, OnInit, ViewChild, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from '@env/environment';
import { SharedService } from '@shared/services/shared.service';
import { ICitations, IInitialResponseLettersView, IPostRemediationPlan, IRemediationViewModel, IResponseLettersView, ISiteVisitModel } from 'app/models/mainMenu/mainMenu';
import { ISelectItems } from 'app/models/shared/shared';
import { BusinessService } from 'app/services/business/business.service';
import { ComplaintService } from 'app/services/complaint/complaint.service';
import { MainMenuService } from 'app/services/mainMenu/mainMenu.service';
import { UserService } from 'app/services/user/user.service';

@Component({
  selector: 'app-mainMenu-citations',
  templateUrl: './citations.component.html',
  styleUrls: ['./citations.component.scss'],
  // changeDetection: ChangeDetectionStrategy.Default
})

export class CitationsComponent implements OnInit {
  @Input() countyId: string = '';

  citationsList: ICitations[] = [];

  displayedColumns: string[] = ['complaintId', 'complaintStatus', 'businessName', 'complaintDate', 'address', 'city', 'zipCode'];
  dataSource = new MatTableDataSource<ICitations>(this.citationsList);
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public mainMenu: MainMenuService,
    public complaintService: ComplaintService,
    private businessService: BusinessService,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    // Citations
    this.mainMenu.getCitations(this.countyId).subscribe({
      next: response => {
        // console.log('Citations response:', response);
        this.mainMenu.citationsList = response;
        this.dataSource.data = this.mainMenu.citationsList;
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Complaints");
      },
    });
  }

  gotoComplaint(compId: string) {
    this.complaintService.complaintId = +compId;
    this.complaintService.complaintTab = 6;
    this.sharedService.doRedirect('complaint/complaint/' + compId);
  }

  gotoBusiness(businessId: string) {
    this.businessService.businessId = +businessId;
    this.businessService.businessTab = 5;
    this.sharedService.doRedirect('business/business');
  }  
}